var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-attendance",
        "dialog-class": "base-modal",
        "body-class": "p-0",
        "hide-header": "",
        "hide-header-close": "",
        "hide-footer": "",
        centered: "",
      },
      on: { hidden: _vm.changeAttendance },
    },
    [
      _c(
        "div",
        {
          class: { "drop-event": _vm.dropEvent?.isEvent },
          attrs: { id: "event-attendance" },
        },
        [
          _vm.dropEvent?.isEvent
            ? _c("div", { staticClass: "event-body" }, [
                !_vm.isMobile
                  ? _c("img", {
                      staticStyle: {
                        position: "absolute",
                        top: "-67px",
                        transform: "translateX(-50%)",
                        width: "140px",
                        left: "50%",
                      },
                      attrs: {
                        src: `${_vm.$s3}/img/common/map/map_event.png?${_vm.$ver}`,
                      },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "event-title",
                    staticStyle: {
                      "font-weight": "bold",
                      color: "#333333",
                      "letter-spacing": "-0.4px",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("modal.attendance.event.title")) +
                        "\n      "
                    ),
                  ]
                ),
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("modal.attendance.event.content", {
                          date: _vm.getPeriodTxt(
                            _vm.dropEvent?.startDate,
                            _vm.dropEvent?.endDate
                          ),
                        })
                      ) +
                      "\n      "
                  ),
                ]),
                _c("div", {
                  staticClass:
                    "drop-event-content d-flex align-items-center place-content-center",
                  staticStyle: { "place-content": "center" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("modal.attendance.event.content1", {
                        url: `${_vm.$s3}/img/common/event/drop_event.webp?${_vm.$ver}`,
                        omc: 0.05,
                      })
                    ),
                  },
                }),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "attendance mb-0",
              class: { event: _vm.attendanceEvent?.isEvent },
            },
            [
              _vm.attendanceEvent?.isEvent
                ? _c("div", { staticClass: "event-title" }, [
                    _c("img", {
                      staticClass: "event-title-bg",
                      attrs: {
                        src: `${_vm.$s3}/img/common/attendance/title_background.webp?${_vm.$ver}`,
                      },
                    }),
                    _c("img", {
                      staticClass: "event-title-img",
                      attrs: {
                        src: `${_vm.$s3}/img/${_vm.lang}/attendance/${_vm.attendanceEvent?.isEvent}.webp?${_vm.$ver}`,
                      },
                    }),
                  ])
                : [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("modal.attendance.title"))),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "modal-content",
                        staticStyle: { background: "#00000000" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("modal.attendance.content")) +
                            "\n\n          "
                        ),
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("modal.attendance.content1", {
                                cnt_attendance: _vm.cnt_attendance,
                              })
                            )
                          ),
                        ]),
                      ]
                    ),
                  ],
              _c(_vm.attendanceBoard, {
                tag: "component",
                attrs: { cnt_attendance: _vm.cnt_attendance },
              }),
              _c("div", { staticClass: "btn-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-btn confirm",
                    class: { event: _vm.attendanceEvent?.isEvent },
                    on: {
                      "~click": function ($event) {
                        return _vm.hideModal()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("modal.confirm")) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }